import { client } from 'filestack-react';
var fileTooBig = "File is too large. Please reduce the file size to under 200MB and try again.";
var filestackPicker = function filestackPicker(filestackCredentials, handleUploadSuccess) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxFiles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
  var filestackClient = client.init(filestackCredentials.api_key, {
    security: {
      policy: filestackCredentials.policy,
      signature: filestackCredentials.signature
    }
  });
  var options = {
    uploadInBackground: false,
    fromSources: ['local_file_system', 'video', 'audio', 'webcam', 'googledrive', 'onedrive'],
    maxFiles: maxFiles,
    onFileSelected: function onFileSelected(file) {
      // If you throw any error in this function it will reject the file selection.
      // The error message will be displayed to the user as an alert.
      if (file.size > 200000000) {
        alert(fileTooBig);
        throw new Error(fileTooBig);
      }
      if (format && file.mimetype !== format) {
        throw new Error("Only ".concat(format, " files are allowed"));
      }
    },
    onFileUploadFailed: function onFileUploadFailed(file, error) {
      alert("There was an error uploading " + file.filename + ". Try again or try a different file format?");
    },
    onFileUploadFinished: function onFileUploadFinished(file) {
      // Upload each file individually
      handleUploadSuccess(file);
    },
    onUploadDone: function onUploadDone(files) {
      // All done! nothing to do here.
      // Content has been refreshed via the POST requests above
    }
  };
  return filestackClient.picker(options);
};
export default filestackPicker;